import AppConstants from '../constants/AppConstants';
import { AxiosPublicHolidaysClient } from '../proxy/ProxyClients';

// const api = new Client(AppConstants.BASE_API_URL, AxiosPublicHolidaysClient);

const PublicHolidaysService = {
  search: async (state: number | null) => {
    if (state) {
      return AxiosPublicHolidaysClient.get(state).then((response) => response);
    }

    return AxiosPublicHolidaysClient.all().then((response) => response);
  }
};

export default PublicHolidaysService;
